import React from "react"
import { reduxForm, formValueSelector } from "redux-form"
import styles from "./styles.scss"
import { Button, TYPES } from "components/Button"
import SelectField from "components/SelectField"
import FieldWrapper from "components/FieldWrapper"
import CheckBoxField from "components/Fields/CheckBoxField"
import Ad from "components/Ad"
import { connect } from "react-redux"
import FileUploadField from "components/Fields/FileUploadField"

class AdForm extends React.Component {
  state = {
    src:''
  }
  
  handleOnChange = inputfile => {
    let reader = new FileReader();
    let file = inputfile.target.files["0"]
      reader.onloadend = () => {
        this.setState({
          src: reader.result
        });
      }
  
      reader.readAsDataURL(file)
  }

  render() {
    const { counties, submitText } = this.props

    let adToRender;
    if (this.state.src) {
      adToRender = <Ad title={this.props.title} body={this.props.body} image={this.state.src}/>
    } else if (this.props.ad) {
      adToRender = <Ad title={this.props.ad.title} body={this.props.ad.body} image={this.props.ad.imgurl}/>
    }

    return (
      <div className={styles.container}>
        <form onSubmit={this.props.handleSubmit}>
          <FieldWrapper
            label="Titel"
            placeholder="Fyll i rubriken till annonsen"
            name="adTitle"
            component="input"
            type="text"
          />

          <FieldWrapper
            label="Body"
            placeholder="Fyll i innehållet till annonsen"
            name="adBody"
            component="input"
            type="text"
          />

          <FieldWrapper
            label="Länk till läs mer"
            placeholder="Fyll i länk"
            name="adUrl"
            component="input"
            type="text"
          />

          <FieldWrapper
            label="Kommun"
            placeholder="Välj en eller flera kommuner"
            name="adCounties"
            options={counties}
            component={SelectField}
          />
          <FieldWrapper
            label="Aktiv"
            name="adIsActive"
            component={CheckBoxField}
            className={styles.checkboxWrapper}
            type="checkbox"
          />
          <FieldWrapper
            label="Annonsbild"
            name="adImage"
            onChange={this.handleOnChange}
            component={FileUploadField}
            className={styles.fileUploadWrapper}
          />

          <Button buttonType={TYPES.SUCCESS}>{submitText}</Button>
        </form>
        <div className={styles.adContainer}>

        {adToRender}
        
        </div>
      </div>
    )
  }
}

AdForm = reduxForm({
  form: "adForm",
})(AdForm)
const selector = formValueSelector("adForm")
AdForm = connect(state => {
  const title = selector(state, "adTitle")
  const body = selector(state, "adBody")
  const image = selector(state, "adImage")
  return {
    title,
    body,
    image,
  }
})(AdForm)
export default AdForm



// WEBPACK FOOTER //
// src/components/AdForm/index.jsx